<nav class="ml-admin-nav mb-4" aria-label="Machine-learning administration">
  <a *ngIf="isAdmin" routerLink="/admin/machine-learning" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
    Lifecycle <span *ngIf="lifecycleBadge" class="nav-count">{{ lifecycleBadge }}</span>
  </a>
  <a *ngIf="isAdmin" routerLink="/admin/machine-learning/training" routerLinkActive="active">Training</a>
  <a *ngIf="isAdmin" routerLink="/admin/machine-learning/governance" routerLinkActive="active">
    Governance <span *ngIf="governanceBadge" class="nav-count">{{ governanceBadge }}</span>
  </a>
  <a *ngIf="isAdmin" routerLink="/admin/machine-learning/deployment-controls" routerLinkActive="active">Deployment</a>
  <a *ngIf="canComplianceOrFinance" routerLink="/admin/machine-learning/predictions" routerLinkActive="active">Predictions</a>
  <a *ngIf="canComplianceOrFinance" routerLink="/admin/machine-learning/withdrawal-risk" routerLinkActive="active">
    Withdrawal Risk <span *ngIf="isAdmin && withdrawalBadge" class="nav-count">{{ withdrawalBadge }}</span>
  </a>
  <a *ngIf="canCompliance" routerLink="/admin/machine-learning/deposit-risk" routerLinkActive="active">
    Deposit Risk <span *ngIf="isAdmin && depositBadge" class="nav-count">{{ depositBadge }}</span>
  </a>
  <a *ngIf="canFinance" routerLink="/admin/machine-learning/matching" routerLinkActive="active">Matching</a>
  <a *ngIf="canFinance" routerLink="/admin/machine-learning/operational-reliability" routerLinkActive="active">
    Reliability <span *ngIf="isAdmin && reliabilityBadge" class="nav-count">{{ reliabilityBadge }}</span>
  </a>
  <a *ngIf="canComplianceOrFinance" routerLink="/admin/machine-learning/evaluation" routerLinkActive="active">Evaluation</a>
  <a *ngIf="canFinance" routerLink="/admin/machine-learning/liquidity" routerLinkActive="active">
    Liquidity <span *ngIf="isAdmin && liquidityBadge" class="nav-count">{{ liquidityBadge }}</span>
  </a>
  <a *ngIf="isAdmin" routerLink="/admin/machine-learning/deployment-health" routerLinkActive="active">
    Deployment Health <span *ngIf="deploymentBadge" class="nav-count nav-count-danger">{{ deploymentBadge }}</span>
  </a>
</nav>
